<div class="title">
  {{ title | i18next }}
  <!-- <div class="title-close-button-wrapper">
    <i class="fal fa-times-circle cancelX" mat-button mat-dialog-close cdkFocusInitial></i>
  </div>

  <h2>
    {{ title | i18next }}
  </h2>
  <div class="line">
    <div></div>
  </div> -->
</div>
<div class="dialog-content">
  <div>
    <label class="input-label">{{'dashboard:Report Name' | i18next}}</label>
    <input matInput [(ngModel)]="data.report.shortDescription" />
  </div>
  <div>
    <label>{{ 'dashboard:Category' | i18next }}</label>
    <ng-select [items]="reportCategories" bindLabel="category" bindValue="id"
      [(ngModel)]="data.report.categoryId" class="select-category" [appendTo]="'#ddl-panel-wrapper'" placeholder="{{'dashboard:Please select Category'| i18next }}">
      <ng-template ng-option-tmp let-item="item" let-index="index" dropdownPosition="bottom">
        <div class="ng-option-template">
          {{item.category}}
        </div>
      </ng-template>
    </ng-select>
    <!-- <select mat-select [(ngModel)]="data.report.categoryId">
      <option value=""></option>
      <option *ngFor="let reportCategory of reportCategories" [value]="reportCategory.id">{{reportCategory.category}}
      </option>
    </select> -->
  </div>
  <div>
    <label>{{ 'dashboard:Custom Description' | i18next }}</label>
    <textarea matInput [(ngModel)]="data.report.userDescription"></textarea>
  </div>
</div>

<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close [ngClass]="['secondary-button']">{{ 'Cancel' | i18next }}</button>
  <button mat-flat-button [disabled]="data.report.shortDescription === ''" [ngClass]="['primary-button']"
    (click)="onSaveClick()">{{ 'Save' | i18next }}</button>
</mat-dialog-actions>
